import React from 'react';
import Editor from '@monaco-editor/react';
import { MONACO_OPTIONS } from 'routes/schema-builder/editorConfig';

// The JSON side of an action's raw view: the editor and the one line that says
// why the text can't be used yet.
const RawConfigEditor = ({
  value,
  onChange,
  error,
  readOnly,
}: {
  value: string;
  onChange: (text: string) => void;
  error: string | null;
  readOnly: boolean;
}) => (
  <div>
    <div
      className={`h-72 overflow-hidden rounded border border-ui-field-outline ${
        readOnly ? 'raw-config-editor-readonly' : ''
      }`}
    >
      <Editor
        height="100%"
        language="json"
        value={value}
        theme="vs"
        options={MONACO_OPTIONS(readOnly)}
        onChange={(text) => onChange(text ?? '')}
      />
    </div>
    {error && (
      <p
        role="alert"
        className="mt-2 text-body-sm text-ui-status-error-destructive"
      >
        {error}
      </p>
    )}
  </div>
);

export default RawConfigEditor;
